import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { AutoscalerRebalancingPlan } from '@cast/types';

import { getRebalancePlanQueryKey } from 'hooks/queries/rebalancer/useRebalancePlansQuery';

export const useExecuteRebalancePlanMutation = (): UseMutationResult<
  AxiosResponse<AutoscalerRebalancingPlan>,
  unknown,
  { clusterId: string; rebalancingPlanId: string },
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clusterId, rebalancingPlanId }) =>
      apiClient.autoscaler.executeRebalancingPlan({
        clusterId,
        rebalancingPlanId,
      }),
    onSuccess: async ({ data: rebalancingPlan }) => {
      await queryClient.invalidateQueries({
        queryKey: getRebalancePlanQueryKey({
          clusterId: rebalancingPlan.clusterId,
        }),
      });
    },
    onError: (error: unknown) => {
      const parsedError = parseApiError(error);

      notify.error(parsedError);
    },
  });
};
